import { redirect } from 'vike/abort'
import { useProfileStore } from "@/pages/cs/profil/profileStore.ts";
import { useBusinessRequestStore } from "@/pages/cs/(businessrequest)/businessRequestStore";
import useItemUpdates from "@/stores/proposalItemUpdates.ts";
import useWorkDetailStore from "@/stores/workdetail.ts";
import { isAuthPOS } from '@/utils/functions';

export async function guard(pageContext: any) {
    console.log("WINDOW", window)
    console.log("typeof window", typeof window)
    console.log("isAuth from login guard: ", isAuthPOS())

    if (pageContext.urlOriginal === '/' && pageContext.urlPathname != "/") {
        throw redirect(pageContext.urlPathname)
    }

    const profileStore = useProfileStore()
    const businessRequestStore = useBusinessRequestStore()
    const itemStore = useItemUpdates()
    const workDetailStore = useWorkDetailStore()

    await profileStore.handleSaveChangesBeforeLeaving(pageContext)
    await businessRequestStore.handleSaveChangesBeforeLeaving(pageContext)
    await itemStore.handleSaveChangesBeforeLeaving(pageContext)
    await workDetailStore.handleSaveChangesBeforeLeaving(pageContext)
}